/**
 * Sanitize string for safe display/storage (strip tags, trim, limit length).
 */
export function sanitizeText(value, maxLength = 10000) {
  if (value == null) return "";
  const s = String(value).replace(/<[^>]*>/g, "").trim();
  return maxLength ? s.slice(0, maxLength) : s;
}

/**
 * For live input: strip HTML and limit length but do NOT trim, so spaces are accepted.
 */
export function sanitizeTextInput(value, maxLength = 10000) {
  if (value == null) return "";
  const s = String(value).replace(/<[^>]*>/g, "");
  return maxLength ? s.slice(0, maxLength) : s;
}

/**
 * Ensure value is a non-negative integer string or number.
 */
export function sanitizeInteger(value) {
  if (value === "" || value == null) return "";
  const n = Math.floor(Number(value));
  return isNaN(n) || n < 0 ? "" : String(n);
}

/**
 * Ensure value is a non-negative number (integer or decimal).
 */
export function sanitizeDecimal(value, maxDecimals = 2) {
  if (value === "" || value == null) return "";
  const n = Number(value);
  if (isNaN(n) || n < 0) return "";
  const fixed = maxDecimals >= 0 ? n.toFixed(maxDecimals) : String(n);
  return fixed.replace(/\.?0+$/, "") || "0";
}

/**
 * Format price display (e.g. 2865789 -> "2,865,789" or "$2,865,789").
 */
export function formatPriceNumber(value) {
  if (value === "" || value == null) return "";
  const n = Number(String(value).replace(/[^0-9.]/g, ""));
  if (isNaN(n)) return "";
  return n.toLocaleString("en-CA", { maximumFractionDigits: 0 });
}

/**
 * Validate required field.
 */
export function required(value) {
  return value != null && String(value).trim() !== "";
}

/**
 * Validate email format.
 */
export function isEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
}
